import { render } from "./InnerLoadingSpinner.vue?vue&type=template&id=1c5ecff0"
import script from "./InnerLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./InnerLoadingSpinner.vue?vue&type=script&lang=js"

import "./InnerLoadingSpinner.vue?vue&type=style&index=0&id=1c5ecff0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QSpinner});
